/* beautiful-react-hooks version: 0.30.0 */
import useStorage from './useStorage.js';
var useLocalStorage = useStorage('local');
export default useLocalStorage;